var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, observable } from 'mobx';
import path from 'ramda/src/path';
import { analyticsTracker } from '@winnin/analytics';
import { ALL_LANGUAGES } from 'consts';
import { PUBLIC_PROVIDERS } from 'consts/providers';
import { USER_ROLES } from 'consts/userRoles';
import { mapAllowedModulesToPermissionModules } from 'utils/allowed-modules';
import localStorageUtils from 'utils/localStorageUtils';
let UserStore = (_class = class UserStore {
  constructor() {
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "providers", _descriptor2, this);
    _initializerDefineProperty(this, "terms", _descriptor3, this);
    _initializerDefineProperty(this, "mixpanelLogEvents", _descriptor4, this);
    _initializerDefineProperty(this, "userLanguageOptsWithAll", _descriptor5, this);
    _initializerDefineProperty(this, "userLanguageOptions", _descriptor6, this);
    _initializerDefineProperty(this, "languageDefault", _descriptor7, this);
    _initializerDefineProperty(this, "isFirstAccess", _descriptor8, this);
    _initializerDefineProperty(this, "shouldReloadAfterRouterChange", _descriptor9, this);
    _initializerDefineProperty(this, "reportId", _descriptor0, this);
    _initializerDefineProperty(this, "urlParams", _descriptor1, this);
    _initializerDefineProperty(this, "isImpersonating", _descriptor10, this);
    _initializerDefineProperty(this, "findWorkspace", _descriptor11, this);
  }
  setIsImpersonating(isImpersonating) {
    this.isImpersonating = isImpersonating;
  }
  setUser(user) {
    const userActiveWorkspaces = user?.brands?.filter(brand => brand.status) || [];
    localStorageUtils.setObject('companyId', user?.company?.id);
    const providersList = user?.company?.companyPlan?.providers || user?.company?.plan?.providers;
    this.providers = providersList;
    const isWinner = user?.email?.includes('@winnin') || user?.company?.id === 'WINNIN';
    this.userInfo = {
      ...user,
      brands: userActiveWorkspaces,
      isWinner
    };
  }
  updateUserInfo(newInfo) {
    this.userInfo = {
      ...this.userInfo,
      ...newInfo
    };
  }
  setReportId(reportId) {
    return this.reportId = reportId;
  }
  setUserLanguages(languages) {
    const allOpt = {
      label: 'All',
      value: '',
      disabled: false
    };
    const defaultLanguageOpts = ALL_LANGUAGES.map(language => {
      if (languages.includes(language.value)) {
        return {
          label: language.label,
          value: language.value,
          disabled: false
        };
      } else {
        return {
          label: language.label,
          value: language.value,
          disabled: true
        };
      }
    });
    const languageOptsWithAll = [allOpt, ...defaultLanguageOpts];
    const defaultEnabledLanguages = defaultLanguageOpts.filter(language => !language.disabled);
    if (defaultLanguageOpts.length) {
      this.userLanguageOptions = defaultLanguageOpts;
      this.userLanguageOptsWithAll = languageOptsWithAll;
      this.languageDefault = defaultEnabledLanguages[0];
    }
  }
  hasUserInfo() {
    return !!Object.keys(this.userInfo).length;
  }
  get getRole() {
    const role = this.userInfo.role;
    switch (role) {
      case USER_ROLES.VIEWER:
        return 'viewer';
      case USER_ROLES.WINNIN_LITE:
        return 'winnin-lite';
      case USER_ROLES.EDITOR:
        return 'editor';
      case USER_ROLES.COMPANY_ADMIN:
        return 'company-admin';
      case USER_ROLES.ADMIN:
        return 'admin';
      case USER_ROLES.GUEST:
        return 'guest';
      default:
        return 'unknown role';
    }
  }
  get getActiveWorkspaceModules() {
    const workspaces = this.userInfo.workspaces ?? this.userInfo.brands ?? [];
    const activeId = this.urlParams?.panelId || localStorageUtils.getObject('panelId');
    const workspace = this.findWorkspace(workspaces, activeId);
    const allowedModules = workspace?.workspaceSettings?.allowedModules ?? [];
    return mapAllowedModulesToPermissionModules(allowedModules);
  }
  get(key) {
    if (typeof key === 'string') return path([key], this.userInfo);
    return path(key, this.userInfo);
  }
  toggleMixpanelLogEvents() {
    const next = !this.mixpanelLogEvents;
    analyticsTracker.setDebug(next);
    this.mixpanelLogEvents = next;
  }
  setUrlParams(routingStore) {
    this.urlParams = routingStore;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "providers", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return PUBLIC_PROVIDERS;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "terms", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "mixpanelLogEvents", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return analyticsTracker.isDebugEnabled;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userLanguageOptsWithAll", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userLanguageOptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "languageDefault", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isFirstAccess", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "shouldReloadAfterRouterChange", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "reportId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "urlParams", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isImpersonating", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setIsImpersonating", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsImpersonating"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "findWorkspace", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (workspaces, id) => {
      const brand = (workspaces ?? []).find(brand => brand.id === id);
      return brand;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "setUser", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateUserInfo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateUserInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setReportId", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setReportId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserLanguages", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserLanguages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUserInfo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hasUserInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getRole", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "getRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getActiveWorkspaceModules", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "getActiveWorkspaceModules"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "get", [action], Object.getOwnPropertyDescriptor(_class.prototype, "get"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMixpanelLogEvents", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMixpanelLogEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUrlParams", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUrlParams"), _class.prototype), _class);
export default new UserStore();